export const TEMP_INDEX = {
    VERY_COLD: -2,
    COLD: -1,
    MILD: 0,
    HOT: 1,
    VERY_HOT: 2
};

export default {
    [TEMP_INDEX.VERY_COLD]: {
        color: '#0080f0',
        icon: 'far fa-temperature-frigid',
        uit: "weather.tempVeryCold",
        notice: true,
    },
    [TEMP_INDEX.COLD]: {
        color: '#00bec8',
        icon: 'far fa-temperature-frigid',
        uit: "weather.tempCold",
        notice: true,
    },
    [TEMP_INDEX.MILD]: {
        color: '#ffc32c',
        icon: 'far fa-thermometer-half',
        uit: "weather.tempMild",
        notice: false,
    },
    [TEMP_INDEX.HOT]: {
        color: '#f06400',
        icon: 'far fa-temperature-hot',
        uit: "weather.tempHot",
        notice: true,
    },
    [TEMP_INDEX.VERY_HOT]: {
        color: '#f00000',
        icon: 'far fa-temperature-hot',
        uit: "weather.tempVeryHot",
        notice: true,
    },
}